/**
 * Stable CSS class names for E2E — Force password reset result modal.
 */
export const FPRM = {
    surface: 'force-password-reset-modal',
    header: 'force-password-reset-modal__header',
    title: 'force-password-reset-modal__title',
    inputIconButtonClose: 'force-password-reset-modal-input--icon-button-close',
    resultsPaper: 'force-password-reset-modal__results-paper',
    statTotalRequests: 'force-password-reset-modal__stat-total-requests',
    statSuccessCount: 'force-password-reset-modal__stat-success-count',
    statAlreadyReset: 'force-password-reset-modal__stat-already-reset',
    statOperationStatus: 'force-password-reset-modal__stat-operation-status',
    statErrorMessage: 'force-password-reset-modal__stat-error-message',
    inputIconButtonCopy: 'force-password-reset-modal-input--icon-button-copy',
} as const;

export const fprmCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
